import React from "react"
import { FormGroup } from "react-bootstrap"
import { Field } from "react-final-form"
import ReactSelect from "react-select"

const SelectField = ({ name, label, placeholder, options, onChange }) => {
  return (
    <Field name={name} component="select" type="text" placeholder={placeholder} className="form-control">
      {({ input, meta }) => {
        const metaError = (meta.error || meta.submitError) && meta.touched
        return (
          <FormGroup>
            <div className="d-flex">
              <label className="form-label">{label}</label>
            </div>
            <ReactSelect
              classNamePrefix="react-select"
              value={input?.value}
              options={options}
              isClearable={false}
              onChange={(option) => {
                input.onChange(option)
                if (onChange) {
                  onChange(option)
                }
              }}
            />
            {metaError && <p className="required-message">{meta.error || meta.submitError}</p>}
          </FormGroup>
        )
      }}
    </Field>
  )
}

export default SelectField
